import Model from 'src/storage/base';
import constants from 'src/constants';

export class ClinicProfileModel extends Model {
  id = 'ClinicProfileModel';
  defaultState = () => ({
    clinic: null,
    doctor: null,
    activeTab: 'doctors'
  });
  apiConfig = {};
  _events = {
    profile: 'handleProfile'
  };

  handleProfile = (profile) => {
    this.setState({ user: profile });
  };
  getCurrency = () => {
    return this.state.clinic?.currency || constants.general.defaultCurrency;
  };
}

const model = new ClinicProfileModel();
export default model;
